// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"registration_checkbox__YR8g1"};